import { useEffect, useState } from 'react';
import { Grid, InputLabel, OutlinedInput } from '@mui/material';
import ApartmentIcon from '@mui/icons-material/Apartment';
import { FormDrawer } from '../../../../components/form-drawer';
import { FieldError } from '../../../../components/form-page-parts';
import { hasErrors } from '../../../../utils/validation';
import { IUnidEntityAddRequest } from '../../../../model/scp/entity/request/unid-entity-add-request';
import { validateUnidEntity } from '../context/unid-entity-validation';

interface UnidEntityDrawerProps {
    open: boolean;
    isSaving: boolean;
    onClose: () => void;
    onSave: (request: IUnidEntityAddRequest) => void;
}

export function UnidEntityDrawer({ open, isSaving, onClose, onSave }: UnidEntityDrawerProps) {
    const [form, setForm] = useState<Partial<IUnidEntityAddRequest>>({});
    const [showValidationErrors, setShowValidationErrors] = useState(false);
    const errors = showValidationErrors ? validateUnidEntity(form) : {};

    useEffect(() => {
        if (!open) return;
        setForm({});
        setShowValidationErrors(false);
    }, [open]);

    function update(patch: Partial<IUnidEntityAddRequest>) {
        setForm((current) => ({ ...current, ...patch }));
    }

    function handleSave() {
        if (hasErrors(validateUnidEntity(form))) {
            setShowValidationErrors(true);
            return;
        }
        onSave({ unitCode: form.unitCode!.trim(), name: form.name!.trim(), ibgeCode: form.ibgeCode!.trim() });
    }

    return (
        <FormDrawer
            open={open}
            icon={<ApartmentIcon />}
            title="Nova unidade"
            subtitle="Unidade da entidade usada em compras, IRPs e contratos"
            saveLabel="Adicionar unidade"
            isSaving={isSaving}
            onClose={onClose}
            onSave={handleSave}
        >
            <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                    <InputLabel required>Código da Unidade</InputLabel>
                    <OutlinedInput fullWidth autoFocus autoComplete="off" value={form.unitCode || ''} onChange={(e) => update({ unitCode: e.target.value })} error={!!errors.unitCode} />
                    <FieldError message={errors.unitCode} />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <InputLabel required>Código IBGE</InputLabel>
                    <OutlinedInput fullWidth autoComplete="off" value={form.ibgeCode || ''} onChange={(e) => update({ ibgeCode: e.target.value })} error={!!errors.ibgeCode} />
                    <FieldError message={errors.ibgeCode} />
                </Grid>
                <Grid item xs={12}>
                    <InputLabel required>Nome</InputLabel>
                    <OutlinedInput fullWidth autoComplete="off" value={form.name || ''} onChange={(e) => update({ name: e.target.value })} error={!!errors.name} />
                    <FieldError message={errors.name} />
                </Grid>
            </Grid>
        </FormDrawer>
    );
}
